<template>
  <div>
    <breadcrumbs :data="list_breadcrumbs"></breadcrumbs>
    <form class="section" @submit.prevent="submitData()">
      <div class="field">
        <label class="label">Title</label>
        <div class="control">
          <input v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('title')}" name="title" type="text" v-model="title">
        </div>
        <span class="help is-danger" v-show="errors.has('title')" v-text="errors.first('title')"></span>
      </div>
      <div class="field">
        <label class="label">Event Ticket Type</label>
        <div class="control">
          <div class="select">
            <select v-model="ticket_type">
              <option v-for="(ticket_type_row, index) in ticket_type_list" :key="index" :value="ticket_type_row.id" v-text="ticket_type_row.title"></option>
            </select>
          </div>
        </div>
      </div>
      <div class="field" v-show="ticket_type === 0 || ticket_type === 2">
        <label class="label">Ticket Price</label>
        <div class="control">
          <money :class="{'input': true, 'is-danger': errors.has('price')}" v-model="price" v-bind="money"></money>
        </div>
        <span class="help is-danger" v-show="errors.has('price')" v-text="errors.first('price')"></span>
      </div>
      <div class="field" v-show="ticket_type === 1" v-for="(event_variant_price_row, index) in event_variant_price_list" :key="index">
        <div class="field">
          <label class="label">Ticket Price</label>
          <div class="control">
            <money :class="{'input': true}" v-model="event_variant_price_list[index].price" v-bind="money"></money>
          </div>
        </div>
        <div class="field">
          <label class="label">Minimal Ticket</label>
          <div class="control">
            <money :class="{'input': true}" v-model="event_variant_price_list[index].minimal" v-bind="number_format"></money>
          </div>
        </div>
        <div class="field">
          <label class="checkbox">
            <input type="checkbox" v-model="event_variant_price_list[index].unlimited"> Unlimited Maximal
          </label>
        </div>
        <div class="field" v-show="event_variant_price_list[index].unlimited === false">
          <label class="label">Maximal Ticket</label>
          <div class="control">
            <money :class="{'input': true}" v-model="event_variant_price_list[index].maximal" v-bind="number_format"></money>
          </div>
        </div>
      </div>
      <div class="field is-grouped" v-show="ticket_type === 1">
        <div class="control">
          <button type="button" class="button is-success" @click="addMoreVariantPrice()">Add More Variant Price</button>
        </div>
      </div>
      <div class="field" v-show="ticket_type === 2">
        <label class="label">Other Event</label>
        <div class="control">
          <div class="select">
            <select v-model="other_event">
              <option v-for="(other_event_row, index) in other_event_list" :key="index" :value="other_event_row.id" v-text="other_event_row.title"></option>
            </select>
          </div>
        </div>
      </div>
      <div class="field" v-show="ticket_type !== 2">
        <label class="label">This event has complimentary ticket?</label>
        <div class="control">
          <label class="radio" v-for="(complimentary_row, index) in complimentary_list" :key="index">
            <input type="radio" name="active" v-model="complimentary" :value="complimentary_row.id"> {{complimentary_row.title}}
          </label>
        </div>
      </div>
      <!-- <div class="field">
        <label class="label">Total Tickets</label>
        <div class="control">
          <money :class="{'input': true, 'is-danger': errors.has('quantity')}" v-model="quantity" v-bind="number_format"></money>
        </div>
        <span class="help is-danger" v-show="errors.has('quantity')" v-text="errors.first('quantity')"></span>
      </div> -->
      <div class="field is-grouped">
        <div class="control">
          <button class="button is-link" type="submit">Submit</button>
        </div>
        <div class="control">
          <button class="button is-danger" type="button" @click="getModalConfirmation('Cancel', 'Are you sure want to cancel?', 'link_back')">Cancel</button>
        </div>
      </div>
    </form>
    <confirmation-modal :data-modal="modal_confirmation_data" @confirm-event="executeModalAction"></confirmation-modal>
  </div>
</template>

<script>
import {ModalConfirmation} from '@/library/mixins/local/ModalConfirmation'
import {Money} from 'v-money'

export default {
  mixins: [ModalConfirmation],
  data () {
    return {
      list_breadcrumbs: [
        {
          title: 'Event',
          path: '/panel/event'
        },
        {
          title: 'Insert',
          path: '/panel/event/insert'
        }
      ],
      title: '',
      price: 0,
      quantity: 0,
      ticket_type_list: [
        {
          id: 0,
          title: 'Quota'
        },
        {
          id: 1,
          title: 'Variant Price'
        },
        {
          id: 2,
          title: 'Quota other Event'
        }
      ],
      ticket_type: 0,
      event_variant_price_list: [
        {
          price: 0,
          minimal: 1,
          unlimited: true,
          maximal: 1,
          remove_button: 0
        }
      ],
      complimentary_list: [
        {
          id: 1,
          title: 'Yes'
        },
        {
          id: 0,
          title: 'No'
        }
      ],
      complimentary: 0,
      other_event: '',
      other_event_list: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'Rp. ',
        suffix: '',
        precision: 0,
        masked: false
      },
      number_format: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      }
    }
  },
  components: {
    Money
  },
  created () {
    if (this.getSessionItem('id_token') === null || this.getSessionItem('access_token') === null) {
      this.$router.push('/panel/logout')
    }
    this.getOtherEvent()
  },
  methods: {
    getOtherEvent () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyGetSession('head/event')
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.other_event_list = response.data.data
          self.other_event = self.other_event_list[0].id
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      }).catch(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        console.log(response)
      })
    },
    addMoreVariantPrice () {
      var tempVariantPrice = {
        price: 0,
        minimal: 1,
        unlimited: 1,
        maximal: 1,
        remove_button: 1
      }

      this.event_variant_price_list.push(tempVariantPrice)
    },
    submitData () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      this.flyPostSession('head/event/insert', {
        title: this.title,
        ticket_type: this.ticket_type,
        price: this.price,
        event_variant_price_list: this.event_variant_price_list,
        complimentary: this.complimentary,
        other_event: this.other_event
        // quantity: this.quantity
      })
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.$router.push('/panel/event')
        } else if (response.data.response_code === -1) {
          self.removeSessionItem('id_token')
          self.removeSessionItem('access_token')
          self.$router.push('/')
        } else {
          var result = response.data.message
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    executeModalAction (confirmData) {
      if (confirmData.label === 'link_back') {
        if (confirmData.flag === true) {
          this.$router.go(-1)
        }
      }

      this.clearModalConfirmationData()
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/panel/event/Insert.vue